<!--首页里4个我们的产品介绍-->
<template>
<div v-if="isPc">
     <el-row :gutter="20" type="flex" justify="center" >
           <el-col :span="18">
                <el-row  type="flex" justify="center" v-for="index in 1" :key="index" :class="index==1? '': 'mt20'">
                        <el-col :span="6" v-for="(item, i) in aboutList.slice((index-1)*4,index*4)" :key="i"  align="center">
                        <div class="div-about-icon-image" :class="{'borderleft': i==0}">
                            <el-image
                            :src="require(`@/assets/images/${item}.jpg`)"
                            class="about-icon-image image-transition-scale2">
                            </el-image>  
                            <div>
                             <strong v-if="i==0" class="font-22 line-height-2">端部自动修磨设备</strong>
                             <strong v-else-if="i==1" class="font-22 line-height-2">端部尺寸检测设备</strong>
                             <strong v-else-if="i==2" class="font-22 line-height-2">平直度检测设备</strong>
                             <strong v-else-if="i==3" class="font-22 line-height-2">内表面缺陷检测设备</strong>
                            </div>
                            <div style="width:85%;text-align:left;margin-top:20px;height:100px">
                            <p v-if="i==0" class="font-14 line-height-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;7*24小时不间断工作，有效降低人工作业的事故概率和劳动强度，显著提升企业管理水平和生产效率。</p>
                            <p v-else-if="i==1" class="font-14 line-height-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;采用三维视觉技术，基于多视角点云重建网络实现管端内外径、壁厚尺寸检测。</p>
                            <p v-else-if="i==2" class="font-14 line-height-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;通过多角度视觉经轮廓三维重建，实现钢管全长任意间距的平直度检测。</p>
                            <p v-else-if="i==3" class="font-14 line-height-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;基于改进U-NET模型的深度学习算法，实现内表面缺陷的实时高精度检测。</p>
                            </div>
                            <div style="width:120px;margin-top:15px"><el-button type="primary" round @click="showDetail(i)" >了解详情</el-button></div>
                        </div>
                        </el-col>
                    </el-row>
           </el-col>
     </el-row>
</div>
<div v-else>
   <div class="divcontainer">
       <el-row :gutter="20"   justify="center" v-for="index in 2" :key="index" :class="index==1? '': 'mt20'">
        <el-col :span="12" v-for="(item, i) in aboutList.slice((index-1)*2,index*2)" :key="i"  align="center">
          <div class="div-about-icon-image">
             <el-image
              :src="require(`@/assets/images/${item}.jpg`)"
              class="about-icon-image image-transition-scale2">
            </el-image>  
             <div>
              <strong v-if="index==1 && i==0" class="font-20 line-height-2">端部自动修磨设备</strong>
              <strong v-else-if="index==1 && i==1" class="font-20 line-height-2">端部尺寸检测设备</strong>
              <strong v-else-if="index==2 && i==0" class="font-20 line-height-2">平直度检测设备</strong>
              <strong v-else-if="index==2 && i==1" class="font-20 line-height-2">内表面缺陷检测设备</strong>
            </div>
            <div style="width:80%">
                <p v-if="index==1 && i==0" class="font-14 line-height-2">7*24小时不间断工作，有效降低人工作业的事故概率和劳动强度，显著提升企业管理水平和生产效率。</p>
                <p v-else-if="index==1 && i==1" class="font-14 line-height-2">采用三维视觉技术，基于多视角点云重建网络实现管端内外径、壁厚尺寸检测。</p>
                <p v-else-if="index==2 && i==0" class="font-14 line-height-2">通过多角度视觉经轮廓三维重建，实现钢管全长任意间距的平直度检测。</p>
                <p v-else-if="index==2 && i==1" class="font-14 line-height-2">改进U-NET模型的深度学习算法，实现内表面缺陷的实时高精度检测。</p>
            </div>
          </div>
        </el-col>
     </el-row>
   </div>
  
</div>
</template> 

<script>
export default {
   name:"AboutDesc",
   data(){
    return {
      isPc:true,
      aboutList: ["product-icon-1", "product-icon-2", "product-icon-3", "product-icon-4"]// 采购云图标
    }
   },
   created(){
      this.isPc = this.$store.state.isPc;
   },
   methods:{
     showDetail(id){
       var path ="/ProductPolish";
       if(id==0)
       {
        path="/ProductPolish";
       }
       else if(id==1)
       {
         path="/ProductCheck";
       }
       else if(id=="2")
       {
         path="/ProductPing";
       }
       else 
       {
          path="/ProductInOut";
       }
       this.$router.push({
        path:path,
      })
    }
   }
}
</script>>

<style scoped>
@import "../../style/main.css";
  .divcontainer{
   width:100%;
   margin: 10px auto 0;
  }

 .div-about-icon-image {
  height: 320px;
  width: 100%;
  overflow: hidden;
  /* border-radius: 5px;*/
  padding: 20px 0 10px 0;
  /* box-shadow: 0 6px 20px 0 #d7e8ff; */
  /* background-color: #fff; */
  border: 1px solid #d5d8db;
  border-top:0;  
  border-right: 0;
    /* background: linear-gradient(to bottom, #f0f3f7 0, #d5d8db 20%); */
}
.borderleft{
 border-left:0;  
}

.borderright{
 border-right:0;  
}

.about-icon-image {
  height: 70px;
  margin: 5px ;
}

.div-about-icon-image .buttondetail{
  /* position: absolute; */
  margin-bottom: 60px;
  /* margin-left:120px; */
}

/* .div-about-icon-image:hover .about-icon-image  {
  transform: scale(1.3, 1.3);
  color: #000;
} */
.div-about-icon-image:hover {
   box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.3);  
}
</style>>
 